// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-portfolio-portfolio-detail-tab-contacts-DeleteContactButton-module__root--B5bBq"};